// removed by extract-text-webpack-plugin
module.exports = {"subFold":"styles__subFold__2tzTU","subHeading":"styles__subHeading__23zWH","details":"styles__details__gs07A","blueHighlight":"styles__blueHighlight__6J3tl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupSubFold/styles.scss
// module id = 419
// module chunks = 0